import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiResponseModel, ApiVisa, Core2Config } from "../../shared";
import { WebsiteCouponHdrLinksContainerModel } from "../../../../../../models/aggregates/cms/website/website-coupon-hdr-links-container.model";
import { Observable } from "rxjs";
import { BaseApiPublicLoginTemplateService } from "../../shared/base-api-public-login-template.service";

@Injectable({ providedIn: "root" })
export class WebsiteCouponHdrLinksService extends BaseApiPublicLoginTemplateService<WebsiteCouponHdrLinksContainerModel, WebsiteCouponHdrLinksContainerModel, WebsiteCouponHdrLinksContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.CMS_PREFIX +
      "website/coupon/hdr/links";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.CMS_PREFIX +
      "website/coupon/hdr/links";
    this.endpoint_path_website_ep_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.CMS_PREFIX +
      "website/coupon/hdr/links/website-ep";
    this.httpClient = http;
  }

  postMultiWebsite(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/backoffice-ep/add-multi-website";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
